/**
 * Kiosks reducer (`data.kiosks`).
 */
import { Map, fromJS } from "immutable";
import * as CONST from "actions/action_constants";

const kiosks = (state = Map({}), action) => {
  const { list, kioskID, kioskData } = action;
  switch (action.type) {
    case CONST.KIOSKS_FETCH_SUCCESS:
      return state.merge(list);
    case CONST.KIOSK_FETCH_SUCCESS: {
      const existing = state.get(kioskID, Map({}));
      const updated = existing.merge(fromJS(kioskData));
      return state.set(kioskID, updated);
    }
    case CONST.KIOSK_CREATE_SUCCESS: {
      if (!kioskData || !kioskData._id) {
        return state;
      }
      const id = kioskData._id;
      return state.merge(fromJS({ [id]: { ...kioskData } }));
    }
    case CONST.KIOSK_CREATE_REVERT_COPY:
      return state.set("revertCopy", state.get(kioskID));
    case CONST.KIOSK_REVERT_CHANGES: {
      const revertData = state.get("revertCopy").toJS();
      revertData.isSaved = true;
      const revertKioskId = revertData._id;
      return state.set(revertKioskId, fromJS(revertData));
    }
    case CONST.KIOSK_PUBLISH_REQUEST:
      return state.setIn([kioskID, "publishStatus"], "");
    case CONST.LOGOUT_SUCCESS:
      return state.clear();
    case CONST.KIOSK_PROP_CHANGE: {
      const selector = [];
      selector.push(kioskID, action.prop);
      return state
        .setIn(selector, action.value)
        .setIn([kioskID, "isSaved"], false);
    }
    case CONST.KIOSK_DELETE_SUCCESS:
      return state.remove(kioskID);
    default:
      return state;
  }
};

export default kiosks;
